<template>
  <div class="row" :class="{'section-loading': isLoading}">
    <div class="col-12">
      <h4 class="text-green text-center">滿期保險金</h4>
      <div class="mb-15">
        <select
          v-model="yearperiod"
          class="form-control form-control-inline form-wide ml-50 w-100"
          >
          <option v-for="item in yearType" :key="`yearType-${item.value}`" :value="item.value">
            {{item.text}}
          </option>
        </select>
      </div>
      <form class="form">
        <div class="panel panel-form searchArea">
          <!-- 保障期間 -->
          <div class="form-group row">
            <label class="col-1 text-right">保障期間</label>
            <div class="col-11 d-inline-grid">
              <!-- 保障期間-1 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-1" v-model="coveragePeriod" value="1">
                <label class="hide-label" for="coveragePeriod-1"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_1"
                  @input="startYear_1 = checkInputLength(startYear_1, 3)"
                  @blur="startYear_1 = checkInputLength(startYear_1, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_1"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-1-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">到</span>
                <input
                  type="number"
                  min="0"
                  v-model="endYear_1"
                  @input="endYear_1 = checkInputLength(endYear_1, 3)"
                  @blur="endYear_1 = checkInputLength(endYear_1, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="yearUnitEnd_1"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-end-1-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
              </div>
              <!-- 保障期間-2 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-2" v-model="coveragePeriod" value="2">
                <label class="hide-label" for="coveragePeriod-2"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_2"
                  @input="startYear_2 = checkInputLength(startYear_2, 3)"
                  @blur="startYear_2 = checkInputLength(startYear_2, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_2"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-2-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-model="yearUnitEnd_2"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option value="3">繳費期滿</option>
                </select>
              </div>
              <!-- 保障期間-3 -->
              <div class="radio radio-inline mb-15">
                <input type="radio" id="coveragePeriod-3" v-model="coveragePeriod" value="3">
                <label class="hide-label" for="coveragePeriod-3"></label>
                <span class="lh-40 ml-50">第</span>
                <input
                  type="number"
                  min="0"
                  v-model="startYear_3"
                  @input="startYear_3 = checkInputLength(startYear_3, 3)"
                  @blur="startYear_3 = checkInputLength(startYear_3, 3)"
                  class="form-control form-control-inline show-input w-100"
                  />
                <select
                  v-model="startYearUnit_3"
                  class="form-control form-control-inline form-wide w-100"
                  >
                  <option v-for="item in year_unit" :key="`year-unit-start-3-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">之後</span>
              </div>
            </div>
          </div>
          <!-- 保障公式 -->
          <div class="form-group row">
            <label class="col-1 text-right">保障公式</label>
            <div class="col-11 d-inline-grid">
              <div class="checkbox radio-inline mb-15">
                <select
                  v-model="maxormin"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option value="0"></option>
                  <option value="1">MAX</option>
                  <option value="2">MIN</option>
                </select>
                <span class="lh-40"> ( </span>
                <select
                  v-model="calculationbasis_first"
                  class="form-control form-control-inline form-wide w-250"
                  >
                  <option v-for="item in calculationbasisFirstList" :key="`calculation-basis-first-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasisfirst_value"
                  @input="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  @blur="calculationbasisfirst_value = checkInputLength(calculationbasisfirst_value, 8)"
                  :class="{'is-invalid': is_calculationbasisfirst_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_first"
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerateList" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率</span>
              </div>
              <div class="checkbox radio-inline mb-15">
                <select
                  v-if="maxormin == '0'" 
                  v-model="operator"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option v-for="item in operatorOption" :key="`operator-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <select
                  v-else
                  v-model="operator"
                  class="form-control form-control-inline form-wide w-80"
                  >
                  <option value="5">，</option>
                </select>
                <select
                  v-model="calculationbasis_second"
                  :class="{'is-invalid': is_calculationbasis_second_Error}"
                  class="form-control form-control-inline form-wide w-250 ml-18"
                  >
                  <option value="0"></option>
                  <option v-for="item in calculationbasisSecondList" :key="`calculation-basis-second-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <input
                  type="number"
                  min="0"
                  v-model="calculationbasissecond_value"
                  @input="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  @blur="calculationbasissecond_value = checkInputLength(calculationbasissecond_value, 8)"
                  :class="{'is-invalid': is_calculationbasissecond_value_Error}"
                  class="form-control form-control-inline show-input w-80"
                  />
                <span class="lh-40">倍 Ｘ</span>
                <select
                  v-model="exchangerate_second"
                  class="form-control form-control-inline form-wide w-150"
                  >
                  <option v-for="item in exchangerateList" :key="`exchangerate-list-${item.value}`" :value="item.value">
                    {{item.text}}
                  </option>
                </select>
                <span class="lh-40">換算成新台幣之買入匯率 )</span>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doUpdate" v-if="isEditMode">更新</button>
            <button type="button" class="btn btn-primary" @click="doInsert" v-else>新增</button>
            <button type="button" class="btn btn-default" @click="doCancel">取消</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mt-40">
      <button type="button" class="btn btn-default"  @click="doDeleteAll">
      全部刪除
      </button>
    </div>
    <div class="col-12">
      <table class="table datatable">
        <thead>
          <tr>
            <th class="text-center" style="width:15%;">排序</th>
            <th class="text-center" style="width:15%;">編輯/刪除</th>
            <th class="text-center" style="width:70%;">保障公式輸入結果</th>
          </tr>
        </thead>
        <tbody v-if="formulaData.length">
          <tr v-for="(item, i) in formulaData" :key="`formula-data-${item.investtype_formula_id}`">
            <td class="text-center" :class="{'active':editIndex === i}">
              <button
                type="button"
                class="btn btn-default fa fa-arrow-up"
                @click="doUpdatePriority(i,-1)"
                :disabled="i === 0 || isEditMode"
                >
              </button>
              <button
                type="button"
                class="btn btn-default fa fa-arrow-down"
                @click="doUpdatePriority(i,1)"
                :disabled="i === formulaData.length-1 || isEditMode"
                >
              </button>
            </td>
            <td class="text-center" :class="{'active':editIndex === i}">
              <button 
                type="button" 
                class="btn btn-sm btn-primary fs-12" 
                :disabled="isEditMode" 
                @click="switchEditMode(item,i)"
                >
              編輯
              </button>
              <button 
                type="button" 
                class="btn btn-sm btn-default fs-12" 
                :disabled="isEditMode" 
                @click="doDelete(item)"
                >
              刪除
              </button>
            </td>
            <td :class="{'active':editIndex === i}">
              {{ item.formula_detail }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h3 class="mb-3">查無保障公式</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getMaturityBenefitFormula,
  addInvestFormula,
  deleteAllInvestFormula,
  deleteInvestFormula,
  updateInvestFormula,
  updateInvestFormulaPriority,
} from "@/service";
export default {
  name: "InvestMaturityBenefit",
  data() {
    return {
      productData: {},
      formulaData: [],
      yearperiod: "",
      coveragePeriod: "1",
      maxormin: "0",
      calculationbasis_first: "128",
      calculationbasis_second: "0",
      calculationbasisfirst_value: null,
      calculationbasissecond_value: null,
      startYear_1: null,
      startYear_2: null,
      startYear_3: null,
      endYear_1: null,
      startYearUnit_1: "1",
      startYearUnit_2: "1",
      startYearUnit_3: "1",
      yearUnitEnd_1: "1",
      yearUnitEnd_2: "3",
      exchangerate_first: "0",
      exchangerate_second: "0",
      operator: "0",

      is_calculationbasisfirst_value_Error: false,
      is_calculationbasissecond_value_Error: false,
      is_calculationbasis_second_Error: false,

      isLoading: false,
      isEditMode: false,
      editIndex: -1,
      editFomulaId: "",
      yearType: [
        {
          text: "所有年期",
          value: "",
        },
      ],
      year_unit: [
        {
          text: "年",
          value: "1",
        },
        {
          text: "歲",
          value: "2",
        },
      ],
      calculationbasisFirstList: [
        {
          text: "基本保額",
          value: "4",
        },
        {
          text: "保單價值",
          value: "128",
        },
        {
          text: "保證最低滿期金額",
          value: "1024",
        },
        {
          text: "單位數",
          value: "2048",
        },
        {
          text: "總繳年繳化表定保費",
          value: "8192",
        },
        {
          text: "總繳表定保費",
          value: "131072",
        },
      ],
      calculationbasisSecondList: [
        {
          text: "基本保額",
          value: "4",
        },
        {
          text: "保單價值",
          value: "128",
        },
        {
          text: "保證最低滿期金額",
          value: "1024",
        },
        {
          text: "結構債滿期保本率",
          value: "4096",
        },
        {
          text: "總繳年繳化表定保費",
          value: "8192",
        },
        {
          text: "總繳表定保費",
          value: "131072",
        },
      ],
      operatorOption: [
        {
          text: "",
          value: "0",
        },
        {
          text: "＋",
          value: "1",
        },
        {
          text: "－",
          value: "2",
        },
        {
          text: "＊",
          value: "3",
        },
        {
          text: "／",
          value: "4",
        },
      ],
      exchangerateList: [
        {
          text: "",
          value: "0",
        },
        {
          text: "美元(USD)",
          value: "2",
        },
        {
          text: "澳幣(AUD)",
          value: "3",
        },
        {
          text: "英鎊(GBP)",
          value: "4",
        },
        {
          text: "歐元(EUR)",
          value: "5",
        },
        {
          text: "紐幣(NZD)",
          value: "6",
        },
        {
          text: "港幣(HKD)",
          value: "7",
        },
        {
          text: "日幣(JPY)",
          value: "8",
        },
        {
          text: "人民幣(CNY)",
          value: "9",
        },
        {
          text: "南非幣(ZAR)",
          value: "10",
        },
      ],
    };
  },
  watch: {
    maxormin: function(val) {
      if (val != "0") {
        this.operator = "5";
      } else if (!this.isEditMode) {
        this.operator = "0";
      }
    },
  },
  methods: {
    init() {
      this.formulaData = [];
      this.doCancel();
      this.isLoading = true;
      getMaturityBenefitFormula(
        this.$store.state.userInfo.id,
        this.productData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formulaData = result.data.investformula.sort(
            (a, b) => parseInt(a.priority) - parseInt(b.priority)
          );
        }
        this.isLoading = false;
      });
    },
    doCancel() {
      if (this.isEditMode) {
        this.isEditMode = false;
        this.editIndex = -1;
        this.editFomulaId = "";
      }
      this.is_calculationbasisfirst_value_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      this.yearperiod = "";
      this.coveragePeriod = "1";
      this.maxormin = "0";
      this.calculationbasis_first = "128";
      this.calculationbasis_second = "0";
      this.calculationbasisfirst_value = null;
      this.calculationbasissecond_value = null;
      this.startYear_1 = null;
      this.startYear_2 = null;
      this.startYear_3 = null;
      this.endYear_1 = null;
      this.startYearUnit_1 = "1";
      this.startYearUnit_2 = "1";
      this.startYearUnit_3 = "1";
      this.yearUnitEnd_1 = "1";
      this.yearUnitEnd_2 = "3";
      this.exchangerate_first = "0";
      this.exchangerate_second = "0";
      this.operator = "0";
    },
    doInsert() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      this.isLoading = true;
      addInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "新增成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    getStartYear() {
      if (this.coveragePeriod == "1") {
        return this.startYear_1 ? this.startYear_1 : "0";
      } else if (this.coveragePeriod == "2") {
        return this.startYear_2 ? this.startYear_2 : "0";
      } else if (this.coveragePeriod == "3") {
        return this.startYear_3 ? this.startYear_3 : "0";
      } else {
        return "0";
      }
    },
    setStartYear(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.startYear_1 = parseInt(value) === 0 ? null : parseInt(value);
      } else if (coveragePeriod == "2") {
        this.startYear_2 = parseInt(value) === 0 ? null : parseInt(value);
      } else if (coveragePeriod == "3") {
        this.startYear_3 = parseInt(value) === 0 ? null : parseInt(value);
      }
    },
    getEndYear() {
      if (this.coveragePeriod == "1") {
        return this.endYear_1 ? this.endYear_1 : "0";
      } else {
        return "0";
      }
    },
    setEndYear(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.endYear_1 = parseInt(value) === 0 ? null : parseInt(value);
      }
    },
    getStartYearUnit() {
      if (this.coveragePeriod == "1") {
        return this.startYearUnit_1;
      } else if (this.coveragePeriod == "2") {
        return this.startYearUnit_2;
      } else if (this.coveragePeriod == "3") {
        return this.startYearUnit_3;
      } else {
        return "0";
      }
    },
    setStartYearUnit(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.startYearUnit_1 = value;
      } else if (coveragePeriod == "2") {
        this.startYearUnit_2 = value;
      } else if (coveragePeriod == "3") {
        this.startYearUnit_3 = value;
      }
    },
    getEndYearUnit() {
      if (this.coveragePeriod == "1") {
        return this.yearUnitEnd_1;
      } else if (this.coveragePeriod == "2") {
        return this.yearUnitEnd_2;
      } else {
        return "0";
      }
    },
    setEndYearUnit(coveragePeriod, value) {
      if (coveragePeriod == "1") {
        this.yearUnitEnd_1 = value;
      } else if (coveragePeriod == "2") {
        this.yearUnitEnd_2 = value;
      }
    },
    doUpdatePriority(index, shift) {
      let thisItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index];
      let targetItem = this.formulaData.map(
        ({ formula_detail, ...keepAttrs }) => keepAttrs
      )[index + shift];
      thisItem.priority = thisItem.priority + shift;
      targetItem.priority = targetItem.priority - shift;

      let reqList = [];
      reqList.push(thisItem);
      reqList.push(targetItem);

      this.isLoading = true;
      updateInvestFormulaPriority(this.$store.state.userInfo.id, reqList).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doUpdate() {
      if (this.doValidate()) {
        return;
      }
      let reqData = this.getReqData();
      reqData.investtype_formula_id = this.editFomulaId;
      updateInvestFormula(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doDelete(item) {
      if (confirm("確認要刪除此筆資料!?")) {
        this.isLoading = true;

        let reqData = {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          investtype_formula_id: item.investtype_formula_id,
          detail: item.formula_detail.replaceAll("%", "％"),
          userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
          userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        };
        deleteInvestFormula(this.$store.state.userInfo.id, reqData).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: "無保障公式可刪除" });
            }
            this.isLoading = false;
          }
        );
      }
    },
    doDeleteAll() {
      if (confirm("確認要刪除所有資料!?")) {
        this.isLoading = true;
        let deleteTypeList = [4]; //4:滿期保險金
        deleteAllInvestFormula(this.$store.state.userInfo.id, {
          productid: this.productData.productId,
          company: this.productData.company.COMPSNM,
          insuranceName: this.productData.insuranceName,
          insuranceCode: this.productData.insuranceCode,
          deletetypelist: deleteTypeList,
          detail: this.formulaData.map(x => x.formula_detail.replaceAll("%", "％")),
        }).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "刪除成功" });
            this.init();
          } else {
            this.$toast.info({ title: "無保障公式可刪除" });
          }
          this.isLoading = false;
        });
      }
    },
    switchEditMode(item, index) {
      this.isEditMode = true;
      this.is_calculationbasisfirst_value_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      this.editIndex = index;
      this.editFomulaId = item.investtype_formula_id;
      this.coveragePeriod = this.getCoveragePeriod(item);
      this.setStartYear(this.coveragePeriod, item.start_year);
      this.setStartYearUnit(this.coveragePeriod, item.start_year_unit);
      this.setEndYearUnit(this.coveragePeriod, item.end_year_unit);
      this.setEndYear(this.coveragePeriod, item.end_year);
      this.maxormin = item.maxormin;
      this.calculationbasis_first = item.calculationbasis_first;
      this.calculationbasisfirst_value = item.calculationbasisfirst_value;
      this.operator = item.operator;
      this.calculationbasis_second = item.calculationbasis_second;
      this.calculationbasissecond_value =
        item.calculationbasissecond_value == "0"
          ? null
          : item.calculationbasissecond_value;
      this.exchangerate_first = item.exchangerate_first;
      this.exchangerate_second = item.exchangerate_second;
      this.yearperiod =
        item.yearperiod && item.year_type && item.year_type != "0"
          ? item.yearperiod + "-" + item.year_type
          : "";
    },
    getCoveragePeriod(item) {
      if (item.start_year_unit == "0" && item.end_year_unit == "0") {
        return "1";
      } else if (item.end_year_unit == "3") {
        return "2";
      } else if (item.end_year_unit == "0") {
        return "3";
      }
      return "1";
    },
    getReqData() {
      return {
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        productid: this.productData.productId,
        ageperiods: this.productData.ageperiods,
        terminableperiods: this.productData.terminableperiods,
        productname: this.productData.insuranceName,
        productcode: this.productData.insuranceCode,
        company: this.productData.company.COMPSNM,
        formulatype: 4, //4:滿期保險金
        underwriting_target: "1", //1:本人
        yearperiod: this.yearperiod ? this.yearperiod.split("-")[0] : "",
        year_type: this.yearperiod ? this.yearperiod.split("-")[1] : "0",
        start_year: this.getStartYear(),
        start_year_unit: this.getStartYearUnit(),
        end_year: this.getEndYear(),
        end_year_unit: this.getEndYearUnit(),
        maxormin: this.maxormin,
        calculationbasis_first: this.calculationbasis_first
          ? this.calculationbasis_first
          : "0",
        calculationbasisfirst_value: this.calculationbasisfirst_value
          ? this.calculationbasisfirst_value
          : "0",
        calculationbasisfirst_unit: "3", //固定放3
        operator: this.operator,
        calculationbasis_second: this.calculationbasis_second,
        calculationbasissecond_value: this.calculationbasissecond_value
          ? this.calculationbasissecond_value
          : "0",
        calculationbasissecond_unit:
          this.calculationbasis_second && this.calculationbasissecond_value
            ? "3"
            : "0",
        rewardsrate_point: "0",
        priority:
          this.formulaData.length > 0
            ? parseInt(this.formulaData[this.formulaData.length - 1].priority) +
              1
            : 1,
        age_limt: "0",
        exchangerate_first: this.exchangerate_first,
        exchangerate_second: this.exchangerate_second,
      };
    },
    doValidate() {
      let isError = false;
      this.is_calculationbasisfirst_value_Error = false;
      this.is_calculationbasissecond_value_Error = false;
      this.is_calculationbasis_second_Error = false;
      if (!this.calculationbasisfirst_value) {
        this.$toast.info({ title: "請輸入第一種計算基礎的倍數" });
        this.is_calculationbasisfirst_value_Error = true;
        isError = true;
      }
      if (
        this.calculationbasis_second != "0" &&
        !this.calculationbasissecond_value
      ) {
        this.$toast.info({ title: "請輸入第二種計算基礎的倍數" });
        this.is_calculationbasissecond_value_Error = true;
        isError = true;
      }
      if (
        this.calculationbasissecond_value &&
        this.calculationbasis_second == "0"
      ) {
        this.$toast.info({ title: "請輸入第二種計算基礎" });
        this.is_calculationbasis_second_Error = true;
        isError = true;
      }

      return isError;
    },
    checkInputLength(value, length) {
      if (value.length > length) {
        return value.slice(0, length);
      }
      return value;
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
    this.yearType = this.productData.ageperiods
      ? [
          ...this.yearType,
          ...this.productData.ageperiods.split(",").map((x) => {
            return { text: x + "歲", value: x + "-2" };
          }),
        ]
      : this.yearType;
    this.yearType = this.productData.terminableperiods
      ? [
          ...this.yearType,
          ...this.productData.terminableperiods.split(",").map((x) => {
            return { text: x + "年期", value: x + "-1" };
          }),
        ]
      : this.yearType;
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}
.fs-12 {
  font-size: 12px;
}
.mr-0 {
  margin-right: 0px !important;
}
.ml-18 {
  margin-left: 18px !important;
}
.lh-40 {
  line-height: 40px;
}
.w-80 {
  width: 80px !important;
}
.w-100 {
  width: 100px !important;
}
.w-150 {
  width: 150px !important;
}
.w-250 {
  width: 250px !important;
}
.mb-15 {
  margin-bottom: 15px;
}
.ml-50 {
  margin-left: 50px !important;
}
.show-input {
  opacity: unset;
  position: unset;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
.hide-label {
  height: 0;
}
.active {
  background-color: #f5dec5;
}
</style>
